/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat =
  ClosedEnum<
    typeof GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat
  >;

export type GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?:
    | GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat
    | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
};

/** @internal */
export const GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat
  > = z.nativeEnum(GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat);

/** @internal */
export const GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat
  > = GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$ {
  /** @deprecated use `GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$inboundSchema;
  /** @deprecated use `GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$outboundSchema;
}

/** @internal */
export const GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$inboundSchema:
  z.ZodType<
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number().int()).default(null),
    format:
      GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$inboundSchema
        .default("json"),
    start: z.nullable(z.number().int()).default(null),
  });

/** @internal */
export type GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$Outbound =
  {
    end: number | null;
    format: string;
    start: number | null;
  };

/** @internal */
export const GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$outboundSchema:
  z.ZodType<
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest
  > = z.object({
    end: z.nullable(z.number().int()).default(null),
    format:
      GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateFormat$outboundSchema
        .default("json"),
    start: z.nullable(z.number().int()).default(null),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$ {
  /** @deprecated use `GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$inboundSchema;
  /** @deprecated use `GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$outboundSchema;
  /** @deprecated use `GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$Outbound;
}

export function getApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequestToJSON(
  getApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest:
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest,
): string {
  return JSON.stringify(
    GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$outboundSchema
      .parse(getApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest),
  );
}

export function getApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3DailyStatsMaxUpdateTransactionsPerSecTillDateRequest' from JSON`,
  );
}
